<template>
  <div :class="$style.container">
      <div :class="$style.body">
          <Item :result=obj v-for="obj in item.info" :key="obj.courseTitle"/>
      </div>
  </div>
</template>
<script>
import Item from './item.vue'
export default {
  data () {
    return {
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },obj: {
      type: Object,
      default: () => {}
    }
  },
  components: {
      Item
  }
}
</script>
<style lang="scss" module>
  @import '../../../../assets/css/default';
  .container {
    margin: 10px 0px;

  }
</style>



// WEBPACK FOOTER //
// src/pages/cruiseShop/checkItems/item/tabItem.vue